import { __decorate } from "tslib";
import { AutoEncoder, EnumDecoder, field, StringDecoder } from '@simonbackx/simple-encoding';
import { SimpleError } from '@simonbackx/simple-errors';
import { LegacyRecordType, OldRecordType } from './LegacyRecordType.js';
// Temporary fix for space in enum....
class TrimEnumDecoder {
    constructor(e) {
        this.enum = e;
    }
    decode(data) {
        let str;
        try {
            str = data.string.trim();
            if (Object.values(this.enum).includes(str)) {
                return str;
            }
        }
        catch (e) {
            try {
                str = data.number;
                if (Object.values(this.enum).includes(str)) {
                    return str;
                }
            }
            catch (e2) {
                throw new SimpleError({
                    code: 'invalid_field',
                    message: `Expected a number or string for enum: ` + Object.values(this.enum).join(', '),
                    field: data.currentField,
                });
            }
        }
        throw new SimpleError({
            code: 'invalid_field',
            message: 'Unknown enum value ' + str + ' expected ' + Object.values(this.enum).join(', '),
            field: data.currentField,
        });
    }
}
export class LegacyRecord extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.description = '';
    }
}
__decorate([
    field({ decoder: new EnumDecoder(LegacyRecordType) })
], LegacyRecord.prototype, "type", void 0);
__decorate([
    field({ decoder: StringDecoder })
], LegacyRecord.prototype, "description", void 0);
__decorate([
    field({ decoder: StringDecoder, optional: true })
], LegacyRecord.prototype, "author", void 0);
/**
 * @deprecated only used for migration. Keep here for at least one year or create a migration that runs in the clients and saves
 */
export class OldRecord extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.description = '';
    }
}
__decorate([
    field({ decoder: new TrimEnumDecoder(OldRecordType) }),
    field({ decoder: new EnumDecoder(OldRecordType), version: 34 })
], OldRecord.prototype, "type", void 0);
__decorate([
    field({ decoder: StringDecoder })
], OldRecord.prototype, "description", void 0);
//# sourceMappingURL=LegacyRecord.js.map